import  { useState } from "react";
import { Button, List, Form, Switch } from "antd";
import { DeleteOutlined, EditFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import "./ClanakList.css";
import "../Dokument/DokumentList.css";
import { formatDateTime } from "../../utils/formatDateTime";
import { updateClanak } from "../../services/clanak.service";

function ClanakList({ clanci, onDeleteClick, setClanci, onEditClick }) {
  const navigate = useNavigate();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const indexOfLast = currentPage * itemsPerPage;
  const indexOfFirst = indexOfLast - itemsPerPage;
  const currentClanci = clanci.slice(indexOfFirst, indexOfLast);

  const totalPages = Math.ceil(clanci.length / itemsPerPage);

  const handleClickClanak = async (clanakId) => {
    navigate(`/zaposleni/clanci/${clanakId}`);
  };

  return (
    <div className="documents-list-container">
      <List
      locale={{ emptyText: "Nema dostupnih članaka." }}
        header={
          <div className="list-header">
            <span className="clanak-col-placeholder"></span>
            <span className="clanak-col-naslov">Naslov</span>
            <span className="clanak-col-autor">Autor</span>
            <span className="clanak-col-datum">Datum Objave</span>
            <span className="clanak-col-status">Status</span>
            <span className="clanak-col-akcije">Akcije</span>
          </div>
        }
        bordered
        dataSource={currentClanci}
        renderItem={(clanak) => (
          <List.Item onClick={() => handleClickClanak(clanak.id)}>
            <div className="list-row-dokument">
              <span className="clanak-col-placeholder"></span>
              <span className="clanak-col-naslov">{clanak.naslov}</span>
              <span className="clanak-col-autor">{clanak.autor}</span>
              <span className="clanak-col-datum">
                {formatDateTime(clanak.datumObjave)}
              </span>
              <span className="clanak-col-status">
                <Form.Item>
                  <Switch
                    checked={clanak.aktivan}
                    onChange={async (checked, event) => {
                      event.stopPropagation();
                      try {
                        const updated = { ...clanak, aktivan: checked };
                        await updateClanak(clanak.id, updated);

                        setClanci((prev) =>
                          prev.map((c) =>
                            c.id === clanak.id ? { ...c, aktivan: checked } : c
                          )
                        );

                        alert(
                          `Članak je ${checked ? "aktiviran" : "deaktiviran"}.`
                        );
                      } catch (err) {
                        alert("Greška pri promeni statusa.");
                      }
                    }}
                  />
                </Form.Item>
              </span>
              <span
                className="clanak-col-akcije"
                style={{ marginRight: "10px" }}
              >
                {" "}
                <Button
                  icon={<DeleteOutlined />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDeleteClick(clanak.id);
                  }}
                />
                <Button
                  icon={<EditFilled />}
                  onClick={(e) => {
                    e.stopPropagation();
                    onEditClick(clanak.id);
                  }}
                  style={{ marginLeft: 8 }}
                />{" "}
              </span>
            </div>
          </List.Item>
        )}
      >
        {totalPages > 1 && (
          <div className="pagination">
            <button
              onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
              disabled={currentPage === 1}
            >
              Prethodna
            </button>

            <span>
              Stranica {currentPage} od {totalPages}
            </span>
            <button
              onClick={() =>
                setCurrentPage((prev) => Math.min(prev + 1, totalPages))
              }
              disabled={currentPage === totalPages}
            >
              Sljedeća
            </button>
          </div>
        )}
      </List>
    </div>
  );
}

export default ClanakList;
